<label *ngIf="label" class="selector-bs__label">{{ label }}</label>
<button
  type="button"
  class="selector-bs__trigger"
  [class.selector-bs__trigger--disabled]="disabled"
  [disabled]="disabled"
  (click)="open()"
>
  <span class="selector-bs__value" [class.selector-bs__value--placeholder]="!selectedLabel">
    {{ selectedLabel || placeholder }}
  </span>
  <span class="material-icons selector-bs__icon">keyboard_arrow_down</span>
</button>

<!--
  Panel + backdrop are projected into the CDK overlay container (which lives
  directly under <body>), bypassing any stacking context an ancestor might
  create. iOS Safari traps `position: fixed` inside ancestor stacking contexts
  produced by transforms or `-webkit-overflow-scrolling: touch`, which would
  otherwise render this panel behind `ds-bottom-sheet` and similar fixed UI.
-->
<ng-template #panelTemplate>
  <div class="selector-bs__overlay" *ngIf="isOpen" [@fadeIn] (click)="close()"></div>
  <div
    class="selector-bs__panel"
    *ngIf="isOpen"
    [@slideUp]
    (@slideUp.done)="onPanelAnimationDone($event)"
    role="dialog"
    aria-modal="true"
  >
    <div class="selector-bs__group">
      <div class="selector-bs__head">
        <div class="selector-bs__title-row">
          <h2 *ngIf="title" class="selector-bs__title mb-0">{{ title }}</h2>
          <button type="button" class="selector-bs__close" aria-label="Cerrar" (click)="close()">
            <span class="material-icons">close</span>
          </button>
        </div>
        <p *ngIf="description" class="selector-bs__subtitle mb-0">{{ description }}</p>
      </div>
      <div class="d-flex flex-column gap-2">
        <ds-option-card
          *ngFor="let option of options; trackBy: trackByValue"
          [label]="option.label"
          [description]="option.description || ''"
          [selected]="option.value === value"
          [disabled]="!!option.disabled"
          (selectedChange)="select(option)"
        ></ds-option-card>
      </div>
    </div>
    <ds-button color="secondary" size="md" width="full" [label]="cancelLabel" (click)="close()"></ds-button>
  </div>
</ng-template>
